__turbopack_context__.v({
  "changeBtn": "_9q2knq_changeBtn",
  "dropdownWrapper": "_9q2knq_dropdownWrapper",
  "golfDropdownActive": "_9q2knq_golfDropdownActive",
  "golfDropdownInactive": "_9q2knq_golfDropdownInactive",
  "iconInfo": "_9q2knq_iconInfo",
  "loader": "_9q2knq_loader",
  "spin": "_9q2knq_spin",
  "xCircleSvg": "_9q2knq_xCircleSvg",
});
